/*
 * Prevent form from repeated submit.
 * Use for form which create new objects - signup form, create quote etc.
 * Usage:
 *      <form onsubmit="return window.utils.prevent_double_submit(this);"> ...
 */
export function prevent_double_submit(form) {
    const cls_name = "is-submitted";

    if (form.classList.contains(cls_name)) {
        return false;
    } else {
        form.classList.add(cls_name);
        return true;
    }
}

/*
 * Dropdown alternative to Bootstrap dropdown
 *
 * Inspired: https://github.com/twbs/bootstrap/blob/master/js/src/dropdown.js
 *
 * Usage:
 *
 *      <div class="dropdown">
 *          <button class="btn btn-primary dropdown-toggle" id="test" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
 *              Dropdown
 *          </button>
 *
 *          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
 *              <a class="dropdown-item" href="#">Don't translate this quote</a>
 *          </div>
 *      </div>
 *
 *      <script>
 *          window.addEventListener('load', function() {
 *              window.utils.dropdown_init();
 *          });
 *      </script>
 *
 */

const DROPDOWN = {
    TOGGLE: '[data-toggle="dropdown"]',
    MENU: ".dropdown-menu",
};

export function dropdown_init() {
    document.addEventListener("click", function (e) {
        const dropdown_toggle = e.target.closest(DROPDOWN.TOGGLE);

        if (dropdown_toggle != null) {
            dropdown_action(dropdown_toggle, "toggle");
        } else {
            dropdown_close_all();
        }
    });
}

function noop(e) {}

// If this is a touch-enabled device we add extra
// empty mouseover listeners to the body's immediate children;
// only needed because of broken event delegation on iOS
// https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
function _fix_ios_mouse_event_bubling(action) {
    if ("ontouchstart" in document.documentElement) {
        [].forEach.call(document.body.children, function (elem) {
            elem[action]("mouseover", noop);
        });
    }
}

function dropdown_close_all() {
    const toggles = document.querySelectorAll(DROPDOWN.TOGGLE);

    [].forEach.call(toggles, function (toggle) {
        dropdown_action(toggle, "remove");
    });
}

function dropdown_action(dropdown_toggle, action) {
    // action = [ 'toggle' | 'add' | 'remove' ]

    const parent = dropdown_toggle.parentNode;
    const dropdown_menu = parent.querySelector(DROPDOWN.MENU);

    // process action
    [parent, dropdown_menu].forEach(function (elem) {
        elem.classList[action]("show");
    });

    var is_active = parent.classList.contains("show");

    // focus or blur dropdown toggle
    if (is_active) {
        dropdown_toggle.focus();
        _fix_ios_mouse_event_bubling("addEventListener");

        // scroll if dropdown_menu is out of viewport
        const viewport_overflow_px = dropdown_menu.getBoundingClientRect().bottom - window.innerHeight + 12;
        if (viewport_overflow_px > 0) {
            window.scrollBy(0, viewport_overflow_px);
        }
    } else {
        dropdown_toggle.blur();
        _fix_ios_mouse_event_bubling("removeEventListener");
    }
}
